import React, { type FC } from 'react';

import type {
	UserPrincipal,
	GroupPrincipal,
	Principal,
	KnownErrors,
	Role,
} from '../../../../commonTypes';

import { UserDetails } from './UserDetails';
import { GroupDetails } from './GroupDetails';

export type PrincipalDetailsProps = {
	principal: Principal;
	isYou: boolean;
	role: Role;
	updateKnownErrors?: (id: string, errors: KnownErrors) => void;
	isDraft: boolean;
};

export const PrincipalDetails: FC<PrincipalDetailsProps> = ({
	principal: { type, ...typeSpecificProps },
	isYou,
	updateKnownErrors,
	role,
	isDraft,
}) => {
	if (type === 'user') {
		return (
			<UserDetails
				{...(typeSpecificProps as UserPrincipal)}
				isYou={isYou}
				updateKnownErrors={updateKnownErrors}
				role={role}
				isDraft={isDraft}
			/>
		);
	} else {
		return <GroupDetails {...(typeSpecificProps as GroupPrincipal)} />;
	}
};
